module.exports = __webpack_public_path__ + "img/avatar_sample.7dfbd79b.svg";